/** @jsxImportSource @emotion/react */
/** @format */
import { css } from "@emotion/react"
import { useContext, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectCoverflow, Pagination } from "swiper/modules"
import { Grid, IconButton } from "@mui/material"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import { Actions } from "../contentful"
import { isCouponActive } from "../contentful/util"
import OptimizedImage from "../OptimizedImage"
import { PreviewContext } from "../../context"

import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/pagination"

const CouponCarousel = ({ storeId, store, ...props }) => {
    const { state: { preview } = {} } = useContext(PreviewContext)
    const [mySwiper, setMySwiper] = useState()
    const [activeIndex, setActiveIndex] = useState(() =>
        store.coupon.length > 2 ? 1 : 0
    )

    const getStoreCouponElements = (coupons, filterCondition) => {
        const couponButtons = []
        const couponImages = coupons
            .filter(filterCondition)
            .map((coupon, idx) => {
                let { buttons, couponImage } = coupon

                couponButtons.push(
                    <Actions
                        key={`actions-${storeId}-${idx}`}
                        alignment="center"
                        cssStyles={
                            "align-items: center; padding: .5rem 1rem !important; margin: 0 -.5rem auto; "
                        }
                        {...{ actions: buttons, coupon, storeId, store }}
                    />
                )

                couponImage = couponImage?.fields || couponImage
                const { height, ...couponImageProps } = couponImage || {} //remove height universally

                return couponImageProps
            })

        return { couponImages, couponButtons }
    }

    const activeCoupons = store?.coupon.filter((coupon) =>
        isCouponActive(coupon, preview)
    )

    // moves the Free Estimate cpn to the the last carousel position
    const {
        couponImages: beginningCouponImages,
        couponButtons: beginningCouponButtons,
    } = getStoreCouponElements(
        activeCoupons,
        ({ title }) => title !== "Free Estimate"
    )
    const { couponImages: lastCouponImage, couponButtons: lastCouponButtons } =
        getStoreCouponElements(
            activeCoupons,
            ({ title }) => title === "Free Estimate"
        )

    const couponImages = [...beginningCouponImages, ...lastCouponImage]
    const couponButtons = [...beginningCouponButtons, ...lastCouponButtons]

    return (
        <>
            <Grid
                item
                container
                justifyContent="space-evenly"
                direction="column"
                overflow="hidden"
                sx={{ mt: "1rem" }}
            >
                <Swiper
                    onSwiper={setMySwiper}
                    onSlideChange={(swiper) =>
                        setActiveIndex(swiper.activeIndex)
                    }
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={"1.8"}
                    initialSlide={store.coupon.length > 2 ? 1 : 0}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 200,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    modules={[EffectCoverflow, Pagination]}
                    css={css`
                        width: 100%;
                        padding: 2rem 0rem;
                        margin: 0;
                        background-color: #006bb7;
                    `}
                >
                    {couponImages?.map((image) => (
                        <SwiperSlide key={image.title}>
                            <OptimizedImage {...{ ...image }} />
                        </SwiperSlide>
                    ))}
                    {couponImages?.length > 1 && (
                        <>
                            <IconButton
                                onClick={() => mySwiper.slidePrev()}
                                disabled={activeIndex === 0}
                                style={{
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: "35%",
                                    transform: "translateX(-50%)",
                                    color:
                                        activeIndex === 0
                                            ? "transparent"
                                            : "white",
                                }}
                            >
                                <ChevronLeftIcon fontSize="large" />
                            </IconButton>
                            <IconButton
                                onClick={() => mySwiper.slideNext()}
                                disabled={
                                    activeIndex === store.coupon.length - 1
                                }
                                style={{
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: "65%",
                                    transform: "translateX(-50%)",
                                    color:
                                        activeIndex === store.coupon.length - 1
                                            ? "transparent"
                                            : "white",
                                }}
                            >
                                <ChevronRightIcon fontSize="large" />
                            </IconButton>
                        </>
                    )}
                </Swiper>
                {couponButtons[activeIndex]}
            </Grid>
        </>
    )
}

export default CouponCarousel
